
// material
import {
    Card, 
    CardHeader, 
    CardContent,
    //Avatar,
    //Divider,
    //Box,
    Grid,
    //Container
    Typography,
    Stack,
} from '@mui/material';

import {
    TempoEmSessao,
    EsforcoDorExercicios,
    SatisfacaoExercicios,
    TaxaRealizacaoExercicios,
    TaxaCorrecaoCorporal,
    HarmoniaGestoExercicios
}from './chartsAtivity'


import FilterSessao from './FilterSessao';
export default function AtividadeUtente() {
   //const theme = useTheme();

   return (
       <Card>
        
       <Stack direction = "row" alignItems="center"  sx={{paddingLeft: 2, paddingTop:2}} m={1}>
            <Typography variant="h4" sx={{ paddingRight: 5}}>Atividade do Utente</Typography>
            <FilterSessao/>
        </Stack>
        
        
       <CardContent>
       
       <Grid container spacing={3}>

            <Grid item xs={12} md={6} lg={4}>
                <TempoEmSessao/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
                <EsforcoDorExercicios/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
                <SatisfacaoExercicios/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
                <TaxaRealizacaoExercicios/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
                <TaxaCorrecaoCorporal/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
                <HarmoniaGestoExercicios/>
            </Grid>

        </Grid>
       </CardContent>
       </Card>
   );
}


